/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';
const initialState = {
  exportAllData: {},
  planType: [],
  rebateProgram: '',
  rebateProgramList: [],
  errorMessagesInRedux: [],
  plan: '',
  errors: [],
  searchResult: [],
  selectedNDC: [],
  selectedSearchType: '',
  isLoading: false,
  labelerSelectedRow: [],
  ndcLeftTableData: [],

  labelerTableData: [],
  displayObj: {
    rebateProgrameName: '',
    searchResult: [],
    selectedNDC: [],
    rebateProgram: '',
    labelerTableData: [],
    rebateProgramList: [],
    rebateProgrameName: '',
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    //Plan type and rebate program
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_NDC_DETAILS:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_NDC_DETAILS:
      return { ...state, ...action.payload };
    case ActionTypes.SET_NDC_DETAILS_REPORT_DATA:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };
    case ActionTypes.SET_NDC_DETAIL_REPORT_DATA_ALL:
      const exportAllData =
        action.key === 'noData'
          ? {}
          : { ...state.exportAllData, [action.key]: action.payload };
      return {
        ...state,
        exportAllData,
      };
    case ActionTypes.SET_NDC_REPORT_DATA_AVAIL:
      return { ...state, ndcreportdetaildata: action.payload };
    case ActionTypes.NDC_SELECT_TYPE:
      return { ...state, selectedSearchType: action.payload };  
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.REFRESH_NDC_DETAILS:
      return { ...initialState, displayObj: state.displayObj };
    case ActionTypes.REFRESH_NDC_DETAILS_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    case ActionTypes.SET_PAGINATION_INDEX_NDC_DETAILS:
      return {
        ...state,
        displayObj: { ...state.displayObj, countValue: action.payload },
      };
    default:
      return state;
  }
};

export default reducer;
